<template>
  <a-modal
    v-model="visible"
    class="model"
    width="30%"
    :title="null"
    :footer="null"
    :closable="false"
    @cancel="handelClose"
  >
    <div class="swiper">
      <div class="container-swiper">
        <swiper
          v-if="imgList.length!=0" id="mySwiper" ref="mySwiper"
          :options="swiperOption"
        >
          <swiper-slide v-for="item of imgList" :key="item.id" class="swiper-item">
            <img class="swiper-img" :src="item" alt="">
          </swiper-slide>
          <div slot="button-next" class="swiper-button-next"></div>
          <div slot="button-prev" class="swiper-button-prev"></div>
          <div slot="pagination" class="swiper-pagination"></div>
        </swiper>
      </div>
    </div>
  </a-modal>
</template>

<script>
// 引入插件
export default {
  props: {
    img: {
      type: String,
      default: ''
    },
    imgList: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
      swiperOption: {
        loop: false,
        autoplay: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    handelBigImg (props) {
      console.log(props)
    },
    handelClose () {
      this.$emit('handelClose', false)
    }
  }
}

</script>
<style lang='less' scoped>
/deep/ .ant-modal-body{
  height: 600px;
  position: relative;
  display: flex;
  padding: 30px;
  flex-direction: column;
  box-sizing: border-box;
  .swiper-pagination{
    position: fixed;
  }
  .swiper-pagination {
     bottom: 26vh;
   }

  // .swiper-button-next{
  //   right: 35vw;
  // }
  // .swiper-button-prev{
  //   left: 35vw;
  // }
  .swiper,.container-swiper,.swiper-container{
    width: 100%;
    height: 100%;
    img{
      width: 100%;
      height: 100%;
      display: block;
    }
  }

}
</style>
